import styled, { css } from 'styled-components';

import { BorderRadius } from '../../tokens/borderRadius';
import { BoxShadow } from '../../tokens/boxShadow';
import { COLORS } from '../../tokens/colors';

export const BlindMenu = styled.div`
    position: relative;
`;

export const DropDownWrapper = styled.div<{ isMobileView?: boolean }>`
    position: absolute;
    top: 100%;
    right: 0;
    background: transparent;
    z-index: 3;

    ${p => p.isMobileView && css`
        position: fixed;
        width: 100vw;
        height: 100%;
        top: 0;
        justify-content: center;
        align-items: flex-end;
        background: rgba(0,0,0,0.2);
    `}
`;

export const DropDownContent = styled.div<{ isMobileView?: boolean }>`
    flex-direction: column;
    align-items: flex-start;
    margin-top: 8px;
    padding: 0;
    border-radius: ${BorderRadius.componentRadius};
    background-color: ${COLORS.BgMain};
    box-shadow: ${BoxShadow.M};

    ${p => p.isMobileView && css`
        width: 100%;
        max-width: 455px;
        align-items: center;
        padding: 24px;
        gap: 12px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

        animation-name: fadeIn;
        animation-fill-mode: backwards;
        animation-duration: 0.5s;
    `}

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;
